import { storage } from '../../../Shared/Utils/authStorage';

/**
 * Where each role's data service lives.
 *
 * <p>This used to be a `isSuperAdmin ? '/admin/data-service' : '/data-service'`
 * ternary copied into every component. That form silently produced the wrong
 * base for a role it did not know about, so a third role inherited the
 * delegate's paths and every link pointed somewhere the route guard rejects.
 * Resolving the base from a table keeps the old two answers identical and gives
 * the restricted roles their own.</p>
 */
const BASES: Record<string, string> = {
  SUPER_ADMIN: '/admin/data-service',
  DELEGATED_ADMIN: '/data-service',
  RECRUITER: '/recruiter/data-service',
  CANDIDATE: '/candidate/data-service',
};

const FALLBACK = '/data-service';

/**
 * Roles that reach data service through a configuration rather than through a
 * per-user grant. They render inside their own dashboard layout and get a
 * smaller surface: no connections screen, because registering a connection is
 * an admin's job.
 */
export const CONFIGURED_ROLES = ['RECRUITER', 'CANDIDATE'];

export const dataServiceBase = (): string => {
  const role = (storage.getRole() || '').toUpperCase();
  return BASES[role] ?? FALLBACK;
};

/** True for the roles that get the restricted, configuration-driven surface. */
export const isConfiguredRole = (role: string | null = storage.getRole()): boolean =>
  CONFIGURED_ROLES.includes((role ?? '').toUpperCase());
